/**
 * MLD-7250
 */
export default {
  async askQuestion(form) {
    const response = await form.post('/api/haystack/ask');
    return response.data;
  },
  async rate(requestID, rating) {
    const form = {
      rating,
    }
    const response = await axios.post(`/api/haystack/requests/${requestID}/rate`, form);
    return response.data;
  }
}
